var React = require('react');

function Quote (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"iconmonstr-quote-5","d":"M15,16.526A14.217,14.217,0,0,1,26.533,3l1.135,2.453a9.227,9.227,0,0,0-5.053,6.629,6.014,6.014,0,0,1,5.071,5.94,5.737,5.737,0,0,1-6,5.744C18.211,23.765,15,21.106,15,16.526Zm-15,0A14.217,14.217,0,0,1,11.536,3l1.135,2.453a9.227,9.227,0,0,0-5.053,6.629,6.014,6.014,0,0,1,5.071,5.94,5.737,5.737,0,0,1-6,5.744C3.214,23.765,0,21.106,0,16.526Z","transform":"translate(0 -3)","fill":"#fff"}));
}

Quote.defaultProps = {"width":"27.686","height":"20.765","viewBox":"0 0 27.686 20.765"};

module.exports = Quote;

Quote.default = Quote;
